'use client';
import React, { useEffect, useState } from 'react';
import { getCookie, setCookie, deleteCookie } from 'cookies-next';

import styles from './cookiesModal.module.scss';
import ButtonSimple from '../HeroBlockBlog/components/ButtonSimple/ButtonSimple';
import FooterButton from '../Footer/components/FooterButton/FooterButton';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

const CookiesModal = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const pathname = usePathname();

  useEffect(() => {
    const hash = window.location.hash;

    if (hash) {
      const id = hash.replace('#', '');
      const el = document.getElementById(id);
      if (el) {
        const yOffset = -80;
        const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    }
  }, [pathname]);

  useEffect(() => {
    const hasSeenModal = getCookie('modalSeen');

    if (!hasSeenModal) {
      setIsModalOpen(true);
    }
  }, []);

  const closeModal = () => {
    setIsModalOpen(false);

    if (getCookie('modalSeen')) {
      deleteCookie('modalSeen');
    }
  };

  const saveCookies = () => {
    setIsModalOpen(false);
    setCookie('modalSeen', 'true', {
      expires: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000 * 3),
      domain:
        document.location.hostname == 'localhost'
          ? 'localhost'
          : '.heraflight.com',
    });
  };

  return (
    isModalOpen && (
      <div className={styles.modalContent}>
        <div className={styles.modalContentLeft}>
          <h5 className={styles.modalContentLeftTitle}>
            This website uses cookies to ensure <br /> you get the best
            experience
          </h5>
          <p className={styles.modalContentLeftText}>
            Learn more about our{' '}
            <Link href="/privacy-policy#cookies">
              <span>Cookie Policy</span>
            </Link>
          </p>
        </div>
        <div className={styles.modalContentRight}>
          <div onClick={saveCookies}>
            <ButtonSimple
              className={styles.submitButton}
              color="accent"
              highContrast
              loading={false}
              size={3}
              state="default ✦"
              variant="solid ✦"
              text={'Accept'}
              iconStart={false}
              iconEnd={false}
              focusRing={false}
              designBlendingMode="/design--blendingmode1.svg"
              designBlendingMode1="/design--blendingmode1.svg"
            />
          </div>

          <FooterButton
            className={styles.footerButton}
            color="accent"
            highContrast={false}
            loading={false}
            size={3}
            state="default ✦"
            variant="solid ✦"
            text={'Decline'}
            iconStart={false}
            iconEnd={false}
            focusRing={false}
            border1={true}
            onClick={closeModal}
          />
        </div>
      </div>
    )
  );
};

export default CookiesModal;
